import { palette } from "../../Theme/palette";
export const MuiDivider = {
    styleOverrides: {
        root: { borderColor: palette.divider }
    }
};
//# sourceMappingURL=Divider.js.map